import { createContext } from 'react'

export type SubscriptionTier = 'free' | 'plus'
export type SubscriptionStatus = 'active' | 'inactive' | 'canceled' | 'past_due' | 'unpaid'

export interface SubscriptionInfo {
  tier: SubscriptionTier
  status: SubscriptionStatus | null
  maxSubmissionsPerMonth: number | null
  currentPeriodEnd: string | null
  cancelAtPeriodEnd: boolean
  polarSubscriptionId: string | null
  loaded: boolean
}

export interface SubscriptionContextValue extends SubscriptionInfo {
  refresh: () => Promise<void>
}

export const DEFAULT_SUBSCRIPTION: SubscriptionInfo = {
  tier: 'free',
  status: null,
  maxSubmissionsPerMonth: 100,
  currentPeriodEnd: null,
  cancelAtPeriodEnd: false,
  polarSubscriptionId: null,
  loaded: false,
}

export const SubscriptionContext = createContext<SubscriptionContextValue>({
  ...DEFAULT_SUBSCRIPTION,
  refresh: async () => {},
})
